module.exports = __webpack_public_path__ + "img/DHI.dc78c5c8.svg";